import React from 'react'

import projectPdf from '../../assets/documents/bb-report.pdf';

const renderTechnologies = (array) => {
    return array.map((item, i) => {
        return <span key={i} className="p-1 pl-0 w-max whitespace-nowrap">{item}</span>
    })
}

const Projects = () => {

    const bbTech = ['Javascript', 'React Native', 'Mongo', 'Parse', 'GCP', 'Google OCR', 'Edamam Api'];
    return (
        <div>

            <div className="mt-10">
                <h3 className="text-h3 m-0 mb-4 text-primary-dark">Budget Buddy</h3>
                <div className="grid grid-cols-1 md:grid-cols-[1fr_4fr] relative gap-[10px] items-center">
                    <div className="project-img-container relative max-md:z-[1] max-md:opacity-[0.15] max-md:[grid-area:1/1]">
                        <div>
                            <img className="max-md:rounded max-md:shadow-[0_10px_30px_-15px] max-md:object-fill" alt="Budget Buddy app showing the grocery receipt upload screen" src={`./images/bb-upload.png`}></img>
                        </div>
                    </div>
                    <div className="max-w-[580px] grid self-start h-full max-md:z-[2] max-md:[grid-area:1/1]">
                        <div className="max-w-[580px]">
                            My uni dissertation project stemming from the problem to manage a food budget and reduce waste.
                            A React Native phone app that:
                            <ul className='ul-arrows'>
                                <li>Digitises grocery receipts</li>
                                <li>Manages grocery budget</li>
                                <li>Shows spending analytics and breakdown</li>
                                <li>Tracks fridge items</li>
                                <li>Suggests recipes (prioritising end of life items fridge items)</li>
                            </ul>
                            <a className="animated-link" target="_blank" rel="noreferrer" href={projectPdf}>Dissertation Report</a>
                            <p>This was a challenging project involving technologies that were very novel to me</p>
                        </div>

                        <div className="max-w-[580px] self-end text-primary-main">
                            <div className="flex flex-wrap p-0 m-0">
                                {renderTechnologies(bbTech)}
                            </div>
                        </div>

                    </div>
                </div>
            </div>




        </div>
    )
}

export default Projects
